@if (showTabs() && !layoutService.isFooterTabsDisabled()) {
<div
  class="fixed bottom-[51px] left-0 w-full z-50 transition-all overflow-visible pointer-events-none"
  [ngClass]="{
    'opacity-0 pointer-events-none': layoutService.isFooterTabsDisabled()
  }"
>
  <app-footer-tab
    class="pointer-events-auto"
    [tabs]="tabs"
    [activeTab]="activeTab()"
    [highlightBackground]="isDetailsPage()"
    (tabChange)="onTabChange($event)"
  ></app-footer-tab>
</div>
}

<!-- Floating action buttons: AI Assistant + Quick View -->
<div class="fixed bottom-[24px] right-md z-200 flex items-center gap-sm">
  <!-- Quick View Button (only on list pages) -->
  @if (quickViewService.isAvailable() && !layoutService.isFooterTabsDisabled()) {
  <div
    appClickable
    class="quick-view-toggle-btn bg-white rounded-lg shadow-card w-[42px] h-[42px] cursor-pointer transform transition-all hover:-translate-y-px hover:shadow-card-lg active:scale-[0.98] flex items-center justify-center"
    (click)="quickViewService.toggle()"
    [matTooltip]="quickViewService.isOpen() ? 'Close Quick View' : 'Quick View'"
    matTooltipPosition="above"
  >
    <ic-chevron-down
      [rotate]="quickViewService.isOpen() ? 180 : 0"
      [startColor]="'var(--color-primary-start-color)'"
      [endColor]="'var(--color-primary-end-color)'"
      [width]="18"
      [height]="18"
    ></ic-chevron-down>
  </div>
  }

</div>

<!-- Main Footer Menu -->
<footer
  class="z-[60] fixed bottom-0 left-0 w-full h-12 overflow-x-auto overscroll-x-contain touch-pan-x no-scrollbar bg-white shadow-dropshadow"
>
  <div class="flex w-max min-w-full items-center justify-start gap-4 px-sm xl:justify-center xl:gap-8 h-full">
    @for (menu of menus; track menu.id) {
    <a
      [routerLink]="getMenuLink(menu)"
      (click)="onMenuClick(menu, $event)"
      [matTooltip]="menu.label | translate"
      matTooltipPosition="above"
      (mousedown)="$event.preventDefault()"
      class="flex shrink-0 items-center gap-2 px-3 py-1.5 rounded-md transition-all duration-200 no-underline widget-focus-ring outline-none h-8"
      [style.background-color]="
        activeMenu === menu.id
          ? 'color-mix(in srgb, var(--color-primary-start-color) 12%, transparent)'
          : 'transparent'
      "
    >
      <!-- ICON -->
      <div
        class="relative z-10 cursor-pointer flex items-center justify-center"
      >
        @if(menu.icon === 'home') {
        <ic-home
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="12"
          [height]="14"
        ></ic-home>
        } @if(menu.icon === 'airplane') {

        <ic-plane
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="15"
          [height]="11"
        ></ic-plane>
        } @if(menu.icon === 'tasks') {
        <ic-tasks
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="13"
          [height]="13"
        ></ic-tasks>
        } @if(menu.icon === 'globe') {
        <ic-globe
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="14"
          [height]="14"
        ></ic-globe>
        } @if(menu.icon === 'box') {
        <ic-parcelbox
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="13"
          [height]="14"
        ></ic-parcelbox>
        } @if(menu.icon === 'compass') {
        <ic-transit
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="14"
          [height]="14"
        ></ic-transit>
        } @if(menu.icon === 'warehouse') {
        <ic-warehouse
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="14"
          [height]="14"
        ></ic-warehouse>
        } @if(menu.icon === 'emcs') {
        <ic-emcs
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="14"
          [height]="17"
        ></ic-emcs>
        } @if(menu.icon === 'templates') {
        <ic-declaration-template
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="13"
          [height]="13"
        ></ic-declaration-template>
        } @if(menu.icon === 'truck') {
        <ic-transit
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
          [width]="14"
          [height]="14"
        ></ic-transit>
        } @if(menu.icon === 'import') {
        <ic-import
          [height]="13"
          [width]="13"
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
        ></ic-import>
        } @if(menu.icon === 'export') {
        <ic-export
          [height]="13"
          [width]="13"
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
        ></ic-export>
        } @if(menu.icon === 'graph') {
        <ic-graph
          [height]="13"
          [width]="13"
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
        ></ic-graph>
        } @if(menu.icon === 'commodity-classifier') {
        <ic-commodity-classifier
          [height]="13"
          [width]="13"
          [startColor]="
            activeMenu === menu.id ? 'var(--color-primary-start-color)' : null
          "
          [endColor]="
            activeMenu === menu.id ? 'var(--color-primary-end-color)' : null
          "
        ></ic-commodity-classifier>
        }
      </div>
      <!-- LABEL -->
      <span
        class="text-xs font-semibold tracking-widest transition-colors duration-200 whitespace-nowrap"
        [class.text-gradient-primary]="activeMenu === menu.id"
        [style.color]="
          activeMenu === menu.id ? null : 'var(--color-gray-text, #94a3b8)'
        "
      >
        {{ menu.label | translate }}
      </span>
    </a>
    }
  </div>
</footer>
